<!-- eslint-disable @angular-eslint/template/label-has-associated-control -->
<mat-sidenav-container>
  <mat-sidenav #rulesSidenav position="end" mode="over" class="rules-sidenav" aria-label="Rules panel">
    <div class="rules-header">
      <label class="title">Rules Engine</label>
      <button mat-icon-button (click)="rulesSidenav.close()" aria-label="Close rules panel">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div class="rules-content">
      <mat-tab-group class="admin-tabs" animationDuration="0ms">
        <mat-tab id="app-manage-collections">
          <ng-template mat-tab-label>
            <label class="labelHeading">Build Rules</label>
          </ng-template>
          <ng-template matTabContent>
            <div class="tab-content-container">
              <form [formGroup]="forwardingRuleForm" (ngSubmit)="createForwardingRule()">
                <div class="rule-name-container">
                  <mat-form-field appearance="outline" class="rule-name-field" floatLabel="always">
                    <mat-label>Rule Name</mat-label>
                    <input matInput placeholder="Name for this rule" formControlName="name" autocomplete="off" />
                    <mat-error
                      *ngIf="forwardingRuleForm.get('name')?.invalid && forwardingRuleForm.get('name')?.touched">
                      Rule name is required
                    </mat-error>
                  </mat-form-field>
                </div>
                @if (conditionsFormArray.controls.length > 1) {
                  <div class="match-radio-group-container">
                    <label class="group-label">Logic</label>
                    <mat-radio-group class="radio-col" formControlName="logic_operator" aria-label="Rule logic">
                      <mat-radio-button value="and"
                        ><span class="radio-text">AND (all conditions must match)</span>
                      </mat-radio-button>
                      <mat-radio-button value="or"
                        ><span class="radio-text">OR (any conditions match)</span></mat-radio-button
                      >
                    </mat-radio-group>
                  </div>
                }
                <div formArrayName="conditions">
                  <div
                    class="condition-item"
                    *ngFor="let condition of conditionsFormArray.controls; let i = index; trackBy: trackByIndex"
                    [formGroupName]="i">
                    <div class="rule-actions-row">
                      <mat-label>Condition {{ i + 1 }}</mat-label>
                      <button
                        mat-button
                        color="warn"
                        (click)="removeCondition(i)"
                        class="remove-condition-btn"
                        *ngIf="conditionsFormArray.length > 1">
                        <span class="btn-content">
                          <mat-icon aria-hidden="true">delete</mat-icon>
                          <span class="btn-label">Remove condition {{ i + 1 }}</span>
                        </span>
                      </button>
                    </div>

                    <div class="column-rules-container">
                      <mat-form-field appearance="outline" class="select-field" floatLabel="always">
                        <mat-label>Select</mat-label>
                        <mat-select formControlName="column_name">
                          <mat-option *ngFor="let opt of columnOptions" [value]="opt.value">
                            {{ opt.label }}
                          </mat-option>
                        </mat-select>
                        <mat-error>Please select a column</mat-error>
                      </mat-form-field>
                    </div>

                    <div class="match-radio-group-container">
                      <!-- <label class="group-label">Logic</label> -->
                      <mat-radio-group
                        class="radio-col"
                        formControlName="operator"
                        name="matchOperator-{{ i }}"
                        aria-label="Rule logic">
                        <mat-radio-button value="equals"><span class="radio-text">Equals</span> </mat-radio-button>
                        <mat-radio-button value="contains"><span class="radio-text">Contains</span></mat-radio-button>
                        <mat-radio-button value="starts_with"
                          ><span class="radio-text">Starts With</span></mat-radio-button
                        >
                      </mat-radio-group>
                    </div>

                    <div class="value-container">
                      <mat-form-field appearance="outline" class="value-input-field">
                        <mat-label>Value</mat-label>
                        <input
                          matInput
                          placeholder="Value..."
                          formControlName="value"
                          name="value-{{ i }}"
                          autocomplete="off" />
                      </mat-form-field>
                    </div>

                    <mat-divider *ngIf="i < conditionsFormArray.length - 1"></mat-divider>
                  </div>
                </div>
                <div class="condition-container">
                  <div class="add-condition-button">
                    <button mat-stroked-button type="button" (click)="addCondition()">+ Add Condition</button>
                  </div>
                </div>
                <div class="target-collection-container" [class.autocomplete-open]="isTargetAutocompleteOpen">
                  <label class="group-label">Target Collection</label>
                  <mat-form-field appearance="outline" color="accent" class="select-field" (click)="clearInputText()">
                    <mat-icon matSuffix>arrow_drop_down</mat-icon>
                    <input
                      type="text"
                      class="selected-collection-input"
                      placeholder="Select collection"
                      matInput
                      [matAutocomplete]="auto"
                      formControlName="target_collection_id"
                      (input)="filterCollections($event)"
                      [matAutocompletePosition]="'below'"
                      #autocompleteTrigger="matAutocompleteTrigger" />
                    <mat-autocomplete
                      class="collection-autocomplete"
                      #auto="matAutocomplete"
                      [displayWith]="displayFn.bind(this)"
                      (opened)="isTargetAutocompleteOpen = true"
                      (closed)="isTargetAutocompleteOpen = false">
                      <mat-option *ngFor="let collection of filteredCollections" [value]="collection.collection_id">
                        <span [class.hidden-collection]="collection.is_hidden">{{ collection.name }}</span>
                      </mat-option>
                    </mat-autocomplete>
                  </mat-form-field>
                </div>
                <div class="past-future-radio-group-container">
                  <mat-radio-group
                    class="radio-col"
                    [value]="'pastAndFuture'"
                    name="pastAndFuture"
                    formControlName="frequency"
                    aria-label="Rule scope">
                    <mat-radio-button value="pastAndFuture">
                      <span class="radio-text" [class.bold]="pastAndFuture === 'pastAndFuture'"
                        >Move past and future documents to the selected collection</span
                      >
                    </mat-radio-button>
                    <mat-radio-button value="future">
                      <span class="radio-text" [class.bold]="pastAndFuture === 'future'"
                        >Move only future documents to the selected collection</span
                      >
                    </mat-radio-button>
                  </mat-radio-group>
                </div>
                <div class="rule-actions-row">
                  <mat-checkbox class="sync-checkbox" aria-label="In sync"
                    >Keep in sync (adds and removes)
                  </mat-checkbox>
                  <div class="actions-right">
                    <button mat-stroked-button type="button">Done</button>
                    <button mat-flat-button color="primary" type="submit" [disabled]="!isFormValid()">
                      Save &amp; Apply
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </ng-template>
        </mat-tab>
        <mat-tab>
          <ng-template mat-tab-label>
            <label class="labelHeading"
              >Matches
              @if (matches().length > 0) {
                ({{ matches().length }})
              }
            </label>
          </ng-template>
          <ng-template matTabContent>
            <div class="tab-content-container">
              @if (!isLoading && matches().length === 0) {
                <app-no-data-found
                  [title]="'No matching!'"
                  [message]="'There are no existing documents matching the specified rules'" />
              } @else {
                <div class="table-container wrapperTableMatches">
                  <ag-grid-angular
                    #agGridMatch
                    [theme]="theme"
                    style="height: 100%; width: 1000px"
                    [rowData]="matches()"
                    [columnDefs]="colDefsMatch"
                    [defaultColDef]="defaultColDef"
                    [animateRows]="true"
                    [enableBrowserTooltips]="true">
                  </ag-grid-angular>
                </div>
              }
            </div>
          </ng-template>
        </mat-tab>
        <mat-tab>
          <ng-template mat-tab-label>
            <label class="labelHeading">
              Existing Rules
              @if (forwardingRulesList.length > 0) {
                ({{ forwardingRulesList.length }})
              }
            </label>
          </ng-template>
          <ng-template matTabContent>
            <div class="tab-content-container">
              @for (rule of forwardingRulesList; track $index) {
                <mat-card appearance="outlined">
                  <mat-card-header>
                    <mat-card-title>{{ rule.name }}</mat-card-title>
                  </mat-card-header>
                  <mat-card-content>
                    <div class="rule-condition">
                      <div class="rule-conditions-container">
                        @for (condition of rule.conditions; track $index) {
                          <div class="rule-condition">
                            @if (condition.logic_operator && $index > 0) {
                              <p>{{ condition.logic_operator }}</p>
                            }
                            <p class="rule-condition">
                              "{{ condition.column_name }} " {{ condition.operator.toUpperCase() }} "{{
                                condition.value
                              }}"
                            </p>
                            @if ($index === rule.conditions.length - 1) {
                              <mat-icon
                                aria-hidden="false"
                                aria-label="Example home icon"
                                fontIcon="arrow_right_alt"></mat-icon>
                              {{ getCollectionNameById(rule.target_collection_id) }}
                            }
                          </div>
                        }
                      </div>
                    </div>
                  </mat-card-content>
                </mat-card>
              }
            </div>
          </ng-template>
        </mat-tab>
      </mat-tab-group>
    </div>
  </mat-sidenav>

  <mat-sidenav-content>
    <div class="collections-container">
      <div class="options-menu">
        <div class="left-heading">
          <h1>Library</h1>
          <app-ping></app-ping>
        </div>

        <div class="right-options">
          <button mat-button (click)="toggleFilters()">
            <mat-icon>list</mat-icon>
            Filters
          </button>

          <button mat-button (click)="openRules()">
            <mat-icon>assignment</mat-icon>
            Rules
          </button>
          <mat-form-field appearance="outline" color="accent" class="search-field">
            <mat-label>Search</mat-label>
            <input
              matInput
              placeholder="Search..."
              [(ngModel)]="gridFilterText"
              (ngModelChange)="onSearchChange($event)" />
          </mat-form-field>
        </div>
      </div>
      <!-- Filters bar -->
      <div class="filters-container" *ngIf="showFilters">
        <div class="filters-row">
          <mat-form-field appearance="outline" class="filter-field" *ngFor="let ft of filterTypes">
            <mat-label>{{ labelFor(ft) }}</mat-label>
            <mat-select
              multiple
              [(ngModel)]="selectedFilters[ft]"
              [ngModelOptions]="{ standalone: true }"
              [required]="true">
              <!-- "All ..." option uses a sentinel value -->
              <mat-option [value]="ALL_TOKEN" (onSelectionChange)="toggleAll(ft, $event)">
                {{ allLabel(ft) }}
              </mat-option>

              <!-- Real options -->
              <mat-option
                *ngFor="let option of baseOptions[ft]"
                [value]="option"
                (onSelectionChange)="toggleSpecific(ft, option, $event)">
                {{ option }}
              </mat-option>

              <mat-select-trigger>{{ displayTriggerText(ft) }}</mat-select-trigger>
            </mat-select>
            <mat-error *ngIf="isEmpty(ft)"> Please select at least one {{ labelFor(ft).toLowerCase() }}. </mat-error>
          </mat-form-field>
        </div>
        <div class="filters-actions">
          <button mat-stroked-button (click)="clearAllFilters()">Clear All</button>
          <button
            mat-flat-button
            (click)="applyFiltersFromUI()"
            [disabled]="!areTopFiltersValid() && !columnFiltersDirty">
            Apply Filters
          </button>
        </div>
      </div>
      <div class="table-container">
        <ag-grid-angular
          #agGrid
          [theme]="theme"
          style="height: 100%"
          [rowData]="filteredRowData"
          [columnDefs]="colDefs"
          [defaultColDef]="defaultColDef"
          [animateRows]="true"
          [rowSelection]="rowSelection"
          (rowSelected)="onRowSelected($event)"
          [enableBrowserTooltips]="true">
        </ag-grid-angular>
        <app-libraries-selected-document-menu
          [selectedDocuments]="getSelectedDocumentsForMenu()"
          [visible]="showSelectedDocumentsMenu"
          (cloneDocuments)="openCloneDialog()">
        </app-libraries-selected-document-menu>
      </div>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
